import { camposInstituicaoProcesso } from "../../../processos/identificacaoInstitucional";
import { coresTextosGlobais, tamanhosControlesGlobais, tamanhosPaginasAdministrativas } from "../../../estilos/global";
import CabecalhoPaginaSecundaria from "../../../componentes/comuns/CabecalhoPaginaSecundaria";
import AnalistaResponsavel from "../../../componentes/comuns/AnalistaResponsavel";
// =======================
// src/paginas/analise/processos/analiseProcessos.js
// =======================
// =======================
// src/paginas/analise/processos/analiseProcessos.js
// =======================
import { useState, useEffect, useRef, useCallback } from "react";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import { ButtonBase, Container, TextField, Typography, Button, Box, Dialog, DialogTitle, DialogContent, Alert, Fade, Paper, useTheme, useMediaQuery, DialogActions, Tooltip } from "@mui/material";
import SaveIcon from "@mui/icons-material/Save";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import SchoolRoundedIcon from "@mui/icons-material/SchoolRounded";
import LocationOnOutlinedIcon from "@mui/icons-material/LocationOnOutlined";
import CalendarMonthOutlinedIcon from "@mui/icons-material/CalendarMonthOutlined";
import PersonOutlineRoundedIcon from "@mui/icons-material/PersonOutlineRounded";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import AssignmentOutlinedIcon from "@mui/icons-material/AssignmentOutlined";





import WarningIcon from "@mui/icons-material/Warning";



import PersonRemoveIcon from "@mui/icons-material/PersonRemove";
import GroupAddIcon from "@mui/icons-material/GroupAdd";
import CheckIcon from "@mui/icons-material/Check";
import DocumentViewer from "./documentosAnalise";
import { api, fetchDocumentoPdf } from "@api/api";
import JSZip from "jszip";
import { saveAs } from "file-saver";







const applySeiMask = (value) => {
  const numbers = value.replace(/\D/g, "");
  let masked = "";

  if (numbers.length > 0) masked += numbers.substring(0, 4);
  if (numbers.length > 4) masked += `.${numbers.substring(4, 6)}`;
  if (numbers.length > 6) masked += `.${numbers.substring(6, 13)}`;
  if (numbers.length > 13) masked += `/${numbers.substring(13, 17)}`;
  if (numbers.length > 17) masked += `-${numbers.substring(17, 19)}`;

  return masked;
};

const validateSeiFormat = (sei) => {
  const pattern = /^\d{4}\.\d{2}\.\d{7}\/\d{4}-\d{2}$/;
  return pattern.test(sei);
};

const AnalistaPage = () => {
  const { id } = useParams();
  const { key: chaveNavegacao } = useLocation();
  const navigate = useNavigate();
  const contextoConsulta = `${id}:${chaveNavegacao}`;
  const contextoAtualRef = useRef(contextoConsulta);
  contextoAtualRef.current = contextoConsulta;
  const consultaProcessoRef = useRef(null);
  const paginaAtivaRef = useRef(true);
  const [consultaProcesso, setConsultaProcesso] = useState({
    contexto: contextoConsulta, data: null, carregando: true, erro: "",
  });
  const mesmoContexto = consultaProcesso.contexto === contextoConsulta;
  const data = mesmoContexto ? consultaProcesso.data : null;
  const carregandoDados = !mesmoContexto || consultaProcesso.carregando;
  const erroCarregamento = mesmoContexto ? consultaProcesso.erro : "";
  const [numeroSei, setNumeroSei] = useState("");
  const [numeroPortaria, setNumeroPortaria] = useState("");
  const [refreshKey, setRefreshKey] = useState(0);
  const [alert, setAlert] = useState({
    open: false,
    message: "",
    severity: "success",
  });
  const [confirmDialog, setConfirmDialog] = useState(false);
  const [openIdentificacao, setOpenIdentificacao] = useState(false);
  const [campoIdentificacao, setCampoIdentificacao] = useState("sei");
  const [confirmacaoAcao, setConfirmacaoAcao] = useState(null);
  const resolverConfirmacaoRef = useRef(null);

  useEffect(() => {
    paginaAtivaRef.current = true;
    return () => {
      paginaAtivaRef.current = false;
      consultaProcessoRef.current?.abort();
      consultaProcessoRef.current = null;
      resolverConfirmacaoRef.current?.(false);
      resolverConfirmacaoRef.current = null;
    };
  }, []);

  const pedirConfirmacao = (acao) => new Promise((resolve) => {
    if (resolverConfirmacaoRef.current) {
      resolve(false);
      return;
    }
    resolverConfirmacaoRef.current = resolve;
    setConfirmacaoAcao(acao);
  });

  const responderConfirmacao = (confirmado) => {
    const resolver = resolverConfirmacaoRef.current;
    resolverConfirmacaoRef.current = null;
    setConfirmacaoAcao(null);
    resolver?.(confirmado);
  };
  const [isSeiValid, setIsSeiValid] = useState(false);
  const [isAssigning, setIsAssigning] = useState(false);
  const [isUnassigning, setIsUnassigning] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const [isDownloadingAll, setIsDownloadingAll] = useState(false);
  const [downloadStatus, setDownloadStatus] = useState("");
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const fetchData = useCallback(async () => {
    consultaProcessoRef.current?.abort();
    const controller = new AbortController();
    consultaProcessoRef.current = controller;
    const consultaAtiva = () => paginaAtivaRef.current &&
      consultaProcessoRef.current === controller && !controller.signal.aborted &&
      contextoAtualRef.current === contextoConsulta;
    setConsultaProcesso((atual) => ({
      contexto: contextoConsulta,
      data: atual.contexto === contextoConsulta ? atual.data : null,
      carregando: true, erro: "",
    }));
    try {
      const response = await fetch(api.analystProcesses(id), {
        credentials: "include", signal: controller.signal,
      });
      if (!response.ok) throw new Error("Erro ao carregar dados");
      const dados = await response.json();
      if (!consultaAtiva()) return;
      if (!dados || typeof dados !== "object" || Array.isArray(dados)) {
        throw new Error("Resposta inválida da API");
      }
      setConsultaProcesso({ contexto: contextoConsulta, data: dados, carregando: false, erro: "" });
      if (dados.numero_sei) {
        setNumeroSei(applySeiMask(dados.numero_sei));
        setIsSeiValid(validateSeiFormat(applySeiMask(dados.numero_sei)));
      } else {
        setNumeroSei("");
        setIsSeiValid(false);
      }
      setNumeroPortaria(dados.numero_portaria || "");
    } catch (error) {
      if (!consultaAtiva()) return;
      console.error("Erro ao buscar dados:", error);
      setConsultaProcesso((atual) => ({
        ...atual, carregando: false,
        erro: "Não foi possível carregar os dados do processo. Tente novamente.",
      }));
    }
  }, [id, contextoConsulta]);

  const handleRejectProcess = async () => {
    if (data?.atribuido_ao_usuario_logado !== true) {
      showAlert(
        "Somente o analista atribuído ao processo pode rejeitá-lo.",
        "warning",
      );
      return;
    }

    if (
      !await pedirConfirmacao("rejeitar")
    )
      return;

    try {
      const response = await fetch(api.RecusarProcesso(id), {
        method: "DELETE",
        credentials: "include",
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || "Erro ao rejeitar processo");
      }

      showAlert("Processo rejeitado com sucesso!", "success");

      setTimeout(() => {
        navigate(-1);
      }, 500);
    } catch (error) {
      console.error("Erro:", error);
      showAlert(error.message, "error");
    }
  };

  useEffect(() => {
    setIsSuccess(false);
    setIsAssigning(false);
  }, [id, chaveNavegacao]);

  useEffect(() => {
    fetchData();
    return () => {
      consultaProcessoRef.current?.abort();
      consultaProcessoRef.current = null;
    };
  }, [fetchData, refreshKey]);

  const showAlert = (message, severity) => {
    setAlert({ open: true, message, severity });
    setTimeout(() => {
      setAlert((prev) => ({ ...prev, open: false }));
    }, 5000);
  };

  const isProcessCompleted = data?.concluida === true;
  const isAssociated = data?.associado === true;
  const podeRejeitarProcesso = data?.atribuido_ao_usuario_logado === true;

  const abrirIdentificacao = (campo) => {
    if (isProcessCompleted) return;
    const seiAtual = data.numero_sei ? applySeiMask(data.numero_sei) : "";
    setNumeroSei(seiAtual);
    setIsSeiValid(validateSeiFormat(seiAtual));
    setNumeroPortaria(data.numero_portaria || "");
    setCampoIdentificacao(campo);
    setAlert((atual) => ({ ...atual, open: false }));
    setOpenIdentificacao(true);
  };

  useEffect(() => setOpenIdentificacao(false), [id, chaveNavegacao]);


  const handleSaveSei = async () => {
    if (!validateSeiFormat(numeroSei)) {
      showAlert(
        "O número SEI deve estar no formato XXXX.XX.XXXXXXX/XXXX-XX",
        "error",
      );
      return;
    }

    try {
      const numeroSeiSemMascara = numeroSei.replace(/\D/g, "");

      const response = await fetch(api.analystSei(id), {
        method: "PATCH",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ numero_sei: numeroSeiSemMascara }),
        credentials: "include",
      });

      if (!response.ok) throw new Error("Erro ao atualizar SEI");

      showAlert("Número SEI atualizado com sucesso", "success");
      setRefreshKey((prev) => prev + 1);
    } catch (error) {
      console.error("Erro:", error);
      showAlert(error.message, "error");
    }
  };

  const handleSeiChange = (e) => {
    if (isProcessCompleted) return;

    const maskedValue = applySeiMask(e.target.value);

    setNumeroSei(maskedValue);
    setIsSeiValid(validateSeiFormat(maskedValue));
  };

  const handleSeiPaste = (e) => {
    if (isProcessCompleted) return;

    e.preventDefault();
    const numerosColados = e.clipboardData.getData("text").replace(/\D/g, "");
    if (!numerosColados) return;

    const campo = e.target;
    const inicio = campo.selectionStart ?? numeroSei.length;
    const fim = campo.selectionEnd ?? inicio;
    const numeros = numerosColados.length === 19
      ? numerosColados
      : `${numeroSei.slice(0, inicio)}${numerosColados}${numeroSei.slice(fim)}`
        .replace(/\D/g, "");

    if (numeros.length > 19) {
      showAlert("O número SEI deve conter 19 dígitos. Confira o conteúdo copiado.", "warning");
      return;
    }

    const valorFormatado = applySeiMask(numeros);
    setNumeroSei(valorFormatado);
    setIsSeiValid(validateSeiFormat(valorFormatado));
  };

  const handleAssignAnalyst = async () => {
    if (isAssigning) return;
    const contextoAtribuicao = contextoConsulta;
    const mesmaPagina = () => paginaAtivaRef.current && contextoAtualRef.current === contextoAtribuicao;
    setIsAssigning(true);

    try {
      const response = await fetch(api.AssociateProcessAna(id), {
        method: "PATCH",
        credentials: "include",
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || "Erro ao atribuir analista");
      }

      if (!mesmaPagina()) return;
      setIsSuccess(true);
      showAlert("Processos abertos da escola atribuídos com sucesso!", "success");
      await fetchData();
    } catch (error) {
      if (mesmaPagina()) {
        console.error("Erro:", error);
        showAlert(error.message, "error");
      }
    } finally {
      if (mesmaPagina()) { setIsSuccess(false); setIsAssigning(false); }
    }
  };

  const handleUnassignAnalyst = async () => {
    const confirmed = await pedirConfirmacao("desatribuir");

    if (!confirmed) return;

    setIsUnassigning(true);

    try {
      const response = await fetch(api.DisassociateProcessAna(id), {
        method: "PATCH",
        credentials: "include",
      });

      const responseData = await response.json();

      if (!response.ok) {
        throw new Error(responseData.message || "Erro ao desatribuir analista");
      }

      showAlert(responseData.message, "success");
      setRefreshKey((prev) => prev + 1);
    } catch (error) {
      console.error("Erro:", error);
      showAlert(error.message, "error");
    } finally {
      setIsUnassigning(false);
    }
  };

  const handleSavePortaria = async (confirmado = false) => {
    try {
      const response = await fetch(api.analystPortaria(id), {
        method: "PATCH",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
        body: JSON.stringify({
          numero_portaria: numeroPortaria,
          confirmado: confirmado,
        }),
      });

      if (!response.ok) throw new Error("Erro ao atualizar Portaria");

      showAlert("Número Portaria atualizado com sucesso", "success");
      setOpenIdentificacao(false);
      setRefreshKey((prev) => prev + 1);
      setConfirmDialog(false);
    } catch (error) {
      console.error("Erro:", error);
      showAlert(error.message, "error");
      setConfirmDialog(false);
    }
  };

  const handleDownloadAll = async () => {
    const documentosDisponiveis =
      data?.documentos?.filter((documento) => documento.id) || [];

    if (documentosDisponiveis.length === 0 || isDownloadingAll) return;

    setIsDownloadingAll(true);
    setDownloadStatus(`Preparando 0 de ${documentosDisponiveis.length}...`);

    try {
      const zip = new JSZip();
      let concluidos = 0;

      await Promise.all(
        documentosDisponiveis.map(async (documento) => {
          const blob = await fetchDocumentoPdf(
            api.analystDocumentoConteudo(documento.id),
          );

          const nomeDocumento = documento.nome_documento || "documento";

          zip.file(`${nomeDocumento}.pdf`, blob);

          concluidos += 1;
          setDownloadStatus(
            `Preparando ${concluidos} de ${documentosDisponiveis.length}...`,
          );
        }),
      );

      const content = await zip.generateAsync(
        { type: "blob" },
        ({ percent }) => {
          setDownloadStatus(`Gerando ZIP: ${Math.round(percent)}%`);
        },
      );

      const nomeProcesso = String(data.processo_nome || "")
        .trim()
        .replace(/[<>:"/\\|?*\u0000-\u001f]/g, "-")
        .replace(/[. ]+$/g, "");

      saveAs(content, `${nomeProcesso || `processo-${id}`}.zip`);
    } catch (error) {
      console.error("Erro ao baixar documentos:", error);
      showAlert(
        error.message || "Não foi possível baixar os documentos",
        "error",
      );
    } finally {
      setIsDownloadingAll(false);
      setDownloadStatus("");
    }
  };

  const handleGoBack = () => {
    navigate(-1);
  };

  if (!data)
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        height="100vh"
        bgcolor="var(--sear-superficie, white)"
      >
        {erroCarregamento ? (
          <Alert severity="error" action={<Button color="inherit" onClick={() => fetchData()} disabled={carregandoDados}>Tentar novamente</Button>}>
            {erroCarregamento}
          </Alert>
        ) : carregandoDados ? (
          <Fade in={true}>
            <Typography role="status" variant="h6" color="textSecondary">
              Carregando dados...
            </Typography>
          </Fade>
        ) : null}
      </Box>
    );

  return (
    <Container data-pagina-rolavel="" maxWidth={false} disableGutters sx={{ display:"flex", flexDirection:"column", flex:{md:"1 1 0"}, minHeight:0, gap:1.5, color:coresTextosGlobais.conteudoTabela }}>
      {erroCarregamento && <Alert severity="error" action={<Button color="inherit" onClick={() => fetchData()} disabled={carregandoDados}>Tentar novamente</Button>}>{erroCarregamento}</Alert>}
      {alert.open && !openIdentificacao && <Alert severity={alert.severity} onClose={()=>setAlert({...alert,open:false})}>{alert.message}</Alert>}
      <CabecalhoPaginaSecundaria titulo="Análise de Documento" descricao="Analise os documentos e acompanhe o histórico de correções e reenvios." rotuloVoltar="Voltar aos processos" onVoltar={handleGoBack} sx={{mb:0, flexShrink:0, "& h1 + p":{color:"var(--sear-texto-secundario, #6882a3)"}}} acoes={!isProcessCompleted && <Box sx={{display:"flex",gap:1,"& button":{fontSize:tamanhosControlesGlobais.botao,textTransform:"none",borderRadius:"6px",minHeight:34,boxShadow:"none"}}}>
        {isAssociated ? <Button variant="contained" startIcon={<PersonRemoveIcon/>} onClick={handleUnassignAnalyst} disabled={isUnassigning} sx={{bgcolor:"var(--sear-acao-azul, #0767d8)",color:"#fff",fontWeight:600,minHeight:36,px:2,"&:hover":{bgcolor:"var(--sear-acao-azul-hover, #075bbd)"}}}>{isUnassigning ? "Desatribuindo..." : "Desatribuir"}</Button> : <Button variant="contained" startIcon={isSuccess ? <CheckIcon/> : <GroupAddIcon/>} onClick={handleAssignAnalyst} disabled={isAssigning} sx={{bgcolor:"var(--sear-acao-azul, #0767d8)",color:"#fff",fontWeight:600,minHeight:36,px:2,"&:hover":{bgcolor:"var(--sear-acao-azul-hover, #075bbd)"}}}>{isAssigning ? "Atribuindo..." : isSuccess ? "Atribuído!" : "Atribuir a Mim"}</Button>}
        <Tooltip title={podeRejeitarProcesso ? "" : "Somente o analista atribuído ao processo pode rejeitá-lo."} arrow><Box component="span" sx={{display:"inline-flex"}}><Button variant="outlined" color="error" startIcon={<WarningIcon/>} onClick={handleRejectProcess} disabled={!podeRejeitarProcesso} sx={{bgcolor:"var(--sear-erro-fundo, #fff0f1)",borderColor:"var(--sear-erro-borda, #e8aeb4)",color:"var(--sear-erro-texto, #ac3f4e)",fontWeight:600,minHeight:36,px:2,"&:hover":{bgcolor:"var(--sear-erro-fundo, #ffe4e7)",borderColor:"var(--sear-erro-borda, #d88c96)"}}}>Rejeitar Processo</Button></Box></Tooltip>
      </Box>} />

      <Paper component="section" aria-label="Dados do processo" variant="outlined" sx={{p:1.5,border:"1px solid var(--sear-borda, #d8e9fb)",borderRadius:"10px",background:"linear-gradient(110deg, var(--sear-superficie-azul, #f0f7ff) 0%, var(--sear-superficie, #fbfdff) 80%)",boxShadow:"none",flexShrink:0}}>
        <Box sx={{display:"flex",alignItems:"flex-start",justifyContent:"space-between",gap:1.5}}>
          <Typography component="h2" sx={{color:coresTextosGlobais.tituloSecao,fontSize:tamanhosPaginasAdministrativas.tituloSecao,fontWeight:600,overflowWrap:"anywhere"}}>{data.processo_nome || "Tipo de processo não informado"}</Typography>
        </Box>
        <Box sx={{
          display: "grid",
          gridTemplateColumns: {
            xs: "minmax(0, 1fr)",
            sm: "repeat(2, minmax(0, 1fr))",
            md: "repeat(3, minmax(0, 1fr))",
            lg: "minmax(220px, 1.4fr) minmax(100px, .75fr) minmax(110px, .65fr) minmax(180px, 1fr) minmax(140px, .9fr) minmax(140px, .9fr)",
          },
          gap: 1.5,
          mt: 1,
        }}>
          {[
            ...camposInstituicaoProcesso(data).map((campo) => ({ ...campo, Icone: SchoolRoundedIcon })),
            { rotulo: "Município", valor: data.municipio, Icone: LocationOnOutlinedIcon },
            { rotulo: "Data de início", valor: new Date(data.data_criacao).toLocaleDateString("pt-BR"), Icone: CalendarMonthOutlinedIcon },
            { rotulo: "Analista responsável", valor: data.analista_nome || (data.id_analista ? "Nome não disponível" : "Não atribuído"), Icone: PersonOutlineRoundedIcon },
            { rotulo: "Nº SEI", valor: data.numero_sei ? applySeiMask(data.numero_sei) : "Não informado", campo: "sei", Icone: DescriptionOutlinedIcon },
            { rotulo: "Nº Portaria", valor: data.numero_portaria || "Não informada", campo: "portaria", Icone: AssignmentOutlinedIcon },
          ].map(({ rotulo, valor, campo, Icone }) => (
            <Box key={rotulo} sx={{ display: "flex", alignItems: "center", gap: 0.8, minWidth: 0 }}>
              <Icone sx={{ color: "var(--sear-azul, #087cf0)", bgcolor: "var(--sear-superficie-azul, #e1efff)", borderRadius: "50%", p: "6px", width: 18, height: 18, fontSize: 18, boxSizing: "content-box", flexShrink: 0 }} />
              <Box sx={{ minWidth: 0 }}>
              <Typography component="span" sx={{ display: "block", color: "var(--sear-texto-secundario, #6983a4)", fontSize: tamanhosControlesGlobais.rotulo }}>{rotulo}</Typography>
              {rotulo === "Analista responsável" ? (
                <AnalistaResponsavel id={data.id_analista} nome={data.analista_nome} email={data.analista_email} />
              ) : campo && !isProcessCompleted ? (
                <ButtonBase
                  aria-label={campo === "sei" ? "Editar número SEI" : "Editar número Portaria"}
                  onClick={() => abrirIdentificacao(campo)}
                  disableRipple
                  sx={{ display: "inline-flex", alignItems: "flex-start", justifyContent: "flex-start", gap: 0.6, maxWidth: "100%", textAlign: "left", color: coresTextosGlobais.conteudoTabela, fontSize: tamanhosPaginasAdministrativas.conteudoTabela, fontWeight: 400, lineHeight: 1.4, borderRadius: "3px", "&.Mui-focusVisible": { outline: "2px solid var(--sear-borda-forte, #087cf0)", outlineOffset: 2 } }}
                >
                  <Box component="span" sx={{ overflowWrap: "anywhere", minWidth: 0 }}>{valor}</Box>
                  <EditOutlinedIcon sx={{ fontSize: 14, mt: 0.2, color: "var(--sear-azul, #0875df)", flexShrink: 0 }} />
                </ButtonBase>
              ) : (
                <Typography sx={{ color: coresTextosGlobais.conteudoTabela, fontSize: tamanhosPaginasAdministrativas.conteudoTabela, lineHeight: 1.4, overflowWrap: "anywhere" }}>{valor}</Typography>
              )}
              </Box>
            </Box>
          ))}
        </Box>
      </Paper>

      <DocumentViewer processoId={id} versaoOrdem={data.versao_ordem} origemOrdem={data.origem_ordem} podeOrdenar={data.atribuido_ao_usuario_logado === true && data.associado === true} documentos={data.documentos} refreshParent={fetchData} baixarTodos={handleDownloadAll} baixandoTodos={isDownloadingAll} statusDownload={downloadStatus}/>
      <Dialog
        open={openIdentificacao}
        onClose={() => setOpenIdentificacao(false)}
        fullWidth
        maxWidth="sm"
        aria-labelledby="identificacao-processo-titulo"
        PaperProps={{ sx: { width: 530, borderRadius: "10px", borderTop: "4px solid var(--sear-borda-forte, #087cf0)", overflow: "hidden" } }}
      >
        <DialogTitle id="identificacao-processo-titulo" sx={{ px: 2.5, py: 2, color: coresTextosGlobais.tituloPagina, fontSize: tamanhosPaginasAdministrativas.tituloSecao, fontWeight: 600 }}>Identificação do processo</DialogTitle>
        <DialogContent sx={{ px: 2.5, pt: "8px !important", pb: 2 }}>
          {alert.open && <Alert severity={alert.severity} onClose={() => setAlert({ ...alert, open: false })} sx={{ mb: 2 }}>{alert.message}</Alert>}
          <Box sx={{ display: "flex", alignItems: "flex-start", gap: 1, mb: 2 }}>
            <TextField fullWidth label="Número SEI" value={numeroSei} onChange={handleSeiChange} onPaste={handleSeiPaste} autoFocus={campoIdentificacao === "sei"} size="small" placeholder="XXXX.XX.XXXXXXX/XXXX-XX" inputProps={{ maxLength: 25, "aria-label": "Número SEI" }} error={numeroSei.length > 0 && !isSeiValid} helperText={numeroSei.length > 0 && !isSeiValid ? "Formato esperado: XXXX.XX.XXXXXXX/XXXX-XX" : undefined} disabled={isProcessCompleted} sx={{ "& .MuiInputBase-input": { color: coresTextosGlobais.conteudoTabela, fontSize: tamanhosControlesGlobais.descricao } }} />
            <Button variant="contained" onClick={handleSaveSei} disabled={isProcessCompleted || !isSeiValid} sx={{ minHeight: 40, flexShrink: 0, textTransform: "none", fontSize: tamanhosControlesGlobais.botao, borderRadius: "6px", boxShadow: "none" }}>Salvar SEI</Button>
          </Box>
          <Box sx={{ display: "flex", alignItems: "flex-start", gap: 1 }}>
            <TextField fullWidth label="Número Portaria" value={numeroPortaria} onChange={(event) => setNumeroPortaria(event.target.value)} autoFocus={campoIdentificacao === "portaria"} size="small" placeholder="Número Portaria" inputProps={{ "aria-label": "Número Portaria" }} disabled={isProcessCompleted} sx={{ "& .MuiInputBase-input": { color: coresTextosGlobais.conteudoTabela, fontSize: tamanhosControlesGlobais.descricao } }} />
            <Button variant="outlined" onClick={() => setConfirmDialog(true)} disabled={isProcessCompleted} sx={{ minHeight: 40, flexShrink: 0, textTransform: "none", fontSize: tamanhosControlesGlobais.botao, borderRadius: "6px", borderColor: "var(--sear-borda, #c7dff8)" }}>Salvar Portaria</Button>
          </Box>
        </DialogContent>
        <DialogActions sx={{ px: 2.5, py: 1.5, borderTop: "1px solid var(--sear-borda, #dfebf8)" }}>
          <Button variant="outlined" onClick={() => setOpenIdentificacao(false)} sx={{ textTransform: "none", fontSize: tamanhosControlesGlobais.botao, borderRadius: "6px", borderColor: "var(--sear-borda, #c7dff8)" }}>Fechar</Button>
        </DialogActions>
      </Dialog>

      <Dialog open={Boolean(confirmacaoAcao)} onClose={() => responderConfirmacao(false)} fullWidth maxWidth="sm" aria-labelledby="confirmacao-acao-titulo" aria-describedby="confirmacao-acao-descricao" PaperProps={{sx:{borderRadius:"12px",borderTop:"4px solid var(--sear-borda-forte, #087cf0)",overflow:"hidden"}}}>
        <DialogTitle id="confirmacao-acao-titulo" sx={{display:"flex",alignItems:"center",gap:1.25,px:3,pt:2.5,pb:1.5,color:coresTextosGlobais.tituloPagina,fontSize:tamanhosPaginasAdministrativas.tituloSecao,fontWeight:600}}>
          {confirmacaoAcao === "rejeitar" ? <WarningIcon sx={{color:"var(--sear-erro-texto, #bf4655)"}}/> : <PersonRemoveIcon sx={{color:"var(--sear-azul, #087cf0)"}}/>}
          {confirmacaoAcao === "rejeitar" ? "Rejeitar processo" : "Desatribuir analista"}
        </DialogTitle>
        <DialogContent sx={{px:3,pb:2}}>
          <Typography id="confirmacao-acao-descricao" sx={{color:coresTextosGlobais.conteudoTabela,fontSize:tamanhosControlesGlobais.descricao,lineHeight:1.55,mb:2}}>
            {confirmacaoAcao === "rejeitar" ? "O processo e seus documentos serão excluídos permanentemente do sistema." : "A desatribuição alcança os processos abertos da mesma mantenedora e escola selecionada. Se a seleção for todas as escolas, alcança os processos com essa mesma seleção."}
          </Typography>
          <Box sx={{p:1.5,bgcolor:"var(--sear-superficie-azul, #f4f9ff)",border:"1px solid var(--sear-borda, #dceafa)",borderRadius:"8px",mb:2}}>
            <Typography sx={{color:"var(--sear-texto-secundario, #6983a4)",fontSize:tamanhosControlesGlobais.rotulo}}>{confirmacaoAcao === "rejeitar" ? "Processo" : "Escola / seleção deste processo"}</Typography>
            <Typography sx={{color:coresTextosGlobais.conteudoTabela,fontSize:tamanhosControlesGlobais.descricao,mt:.5,overflowWrap:"anywhere"}}>{confirmacaoAcao === "rejeitar" ? data.processo_nome : data.nome_escola}</Typography>
          </Box>
          <Alert severity={confirmacaoAcao === "rejeitar" ? "error" : "warning"} sx={{borderRadius:"8px",fontSize:tamanhosControlesGlobais.descricao}}>
            {confirmacaoAcao === "rejeitar" ? "Esta ação não pode ser desfeita. Confirme somente se deseja excluir o processo." : "Também pode remover a atribuição de outros analistas. Os processos e documentos serão mantidos."}
          </Alert>
        </DialogContent>
        <DialogActions sx={{px:3,py:2,borderTop:"1px solid var(--sear-borda, #e0ebf7)",gap:1,"& button":{textTransform:"none",fontSize:tamanhosControlesGlobais.botao,borderRadius:"6px",boxShadow:"none"}}}>
          <Button autoFocus variant="outlined" onClick={()=>responderConfirmacao(false)} sx={{borderColor:"var(--sear-borda, #c7dff8)"}}>Cancelar</Button>
          <Button variant="contained" color={confirmacaoAcao === "rejeitar" ? "error" : "primary"} onClick={()=>responderConfirmacao(true)}>{confirmacaoAcao === "rejeitar" ? "Rejeitar e excluir" : "Confirmar desatribuição"}</Button>
        </DialogActions>
      </Dialog>
                  {!isProcessCompleted && (
              <Dialog
                open={confirmDialog}
                onClose={() => setConfirmDialog(false)}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                PaperProps={{
                  sx: {
                    borderRadius: "12px",
                    overflow: "hidden",
                    minWidth: isMobile ? "90%" : "400px",
                    background: theme.palette.background.paper,
                    boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.25)",
                  },
                }}
              >
                <Box
                  sx={{
                    background: theme.palette.primary.main,
                    color: "white",
                    p: 3,
                    textAlign: "center",
                  }}
                >
                  <SaveIcon sx={{ fontSize: "2.5rem", mb: 1 }} />
                  <Typography variant="h6" sx={{ fontWeight: "bold" }}>
                    Confirmar Conclusão do Processo
                  </Typography>
                </Box>

                <DialogContent sx={{ p: 3 }}>
                  <Typography
                    variant="body1"
                    sx={{ mb: 2, textAlign: "center" }}
                  >
                    Você está prestes a concluir o processo com a portaria:
                  </Typography>

                  <Box
                    sx={{
                      backgroundColor: theme.palette.grey[100],
                      borderRadius: "8px",
                      p: 2,
                      mb: 3,
                      textAlign: "center",
                      borderLeft: `4px solid ${theme.palette.primary.main}`,
                    }}
                  >
                    <Typography
                      variant="h6"
                      sx={{
                        fontWeight: "bold",
                        color: theme.palette.primary.dark,
                      }}
                    >
                      {numeroPortaria || "(Nenhum número informado)"}
                    </Typography>
                  </Box>

                  <Box
                    sx={{
                      backgroundColor: theme.palette.warning.light,
                      p: 2,
                      borderRadius: "6px",
                      display: "flex",
                      alignItems: "center",
                      gap: 1,
                    }}
                  >
                    <WarningIcon sx={{ color: theme.palette.warning.dark }} />
                    <Typography
                      variant="body2"
                      sx={{ color: theme.palette.warning.dark }}
                    >
                      Após a confirmação, o processo será marcado como concluído
                      e não poderá ser alterado.
                    </Typography>
                  </Box>
                </DialogContent>

                <DialogActions
                  sx={{
                    p: 2,
                    justifyContent: "center",
                    gap: 2,
                  }}
                >
                  <Button
                    onClick={() => setConfirmDialog(false)}
                    variant="outlined"
                    sx={{
                      borderRadius: "6px",
                      px: 3,
                      py: 1,
                      fontWeight: "bold",
                      borderColor: theme.palette.grey[400],
                      color: theme.palette.text.secondary,
                      "&:hover": {
                        backgroundColor: theme.palette.grey[100],
                      },
                    }}
                  >
                    Cancelar
                  </Button>
                  <Button
                    onClick={() => handleSavePortaria(true)}
                    variant="contained"
                    color="primary"
                    sx={{
                      borderRadius: "6px",
                      px: 3,
                      py: 1,
                      fontWeight: "bold",
                      boxShadow: "none",
                      "&:hover": {
                        backgroundColor: theme.palette.primary.dark,
                        boxShadow: "none",
                      },
                    }}
                  >
                    Confirmar
                  </Button>
                </DialogActions>
              </Dialog>
            )}
    </Container>
  );

};

export default AnalistaPage;
